const fixSafariOffset = {
  methods: {
    singlePixelScroll() {
      let topOffset = window.scrollY;
      setTimeout(function() {
        window.scrollTo(0, topOffset);
        document.body.style.zoom = 1.0000001;
        setTimeout(function() {
          document.body.style.zoom = 1;
        }, 50);
      }, 100);
      console.log('topOffset:', topOffset + 1);
    }
  },
  mounted() {},
  created() {
    window.addEventListener('focus', this.singlePixelScroll);
    window.addEventListener('visibilitychange', this.singlePixelScroll);
  },
  destroyed() {
    window.removeEventListener('focus', this.singlePixelScroll);
    window.removeEventListener('visibilitychange', this.singlePixelScroll);
  }
};

export default fixSafariOffset;
